<template>
  <router-link to="/" class="logo">
    <span v-show="!collapse" style="white-space: nowrap">易哈佛科技后台</span>
    <img v-show="collapse" src="@/assets/images/logo.png" alt="易哈佛科技后台" />
  </router-link>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ehfLogo',
    components: {},
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
      }),
    },
  }
</script>
<style lang="scss" scoped>
  .logo {
    display: block;
    height: 32px;
    margin: 16px;
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    img {
      border-radius: 4px;
      width: 32px;
    }
  }
</style>
